/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Toast type
 */
export enum TOAST_TYPE {
	INFO = "info",
	SUCCESS = "success",
	WARNING = "warning",
	ERROR = "error",
	LOADING = "loading"
}

/**
 * Toast action
 */
export interface IToastAction {
	label: string;
	title?: string;
	onClick: () => void;
}

/**
 * Toast interface
 */
export interface IToast {
	/** Type */
	type: TOAST_TYPE;
	/** Message */
	message: string;
	/** Optional details */
	details?: string;
	/** Icon - if not set the icon will be selected based on type */
	icon?: string;
	/** Timeout in milliseconds after which the toast will be automatically removed. */
	timeoutMs?: number;
	/** Custom actions that will be displayed as links below the message and details */
	actions?: IToastAction[];
	/**
	 * If toast can be removed by a user click.
	 * Does not prevent close via timeout neither via ToastService.
	 * Defaults to true.
	 */
	isClosable?: boolean;
}
